/* eslint sort-imports-es6-autofix/sort-imports-es6: 0 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// Include global css that applies to all login pages
import 'css/fonts.css';
import 'css/login.css';

import Router from 'client/routes/Router';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueRouter from 'vue-router';

import ConfigService from 'client/util/ConfigService';
import DataDog from 'client/monitoring/DataDog';
import LoadErrorComponent from 'components/LoadError.vue';
import StatusBanner from 'client/containers/Login/StatusBanner.vue';
import FeatureFlagMixin from './stores/FeatureFlagMixin';
import loginStore from './stores/loginStore';

// Integrate global Vue packages
Vue.use(VeeValidate, { classes: true, strict: false });
Vue.use(VueRouter);

Vue.mixin(FeatureFlagMixin);

const StatusBannerClass = Vue.extend(StatusBanner);

ConfigService.initialize().then(() => {
  DataDog.initialize({ serviceName: 'login-ui' });

  loginStore.dispatch('FeatureFlagsModule/fetchFeatureFlags').finally(() => {
    const bannerInstance = new StatusBannerClass();
    bannerInstance.$mount('.banner');

    new Vue({
      template: '<router-view/>',
      router: Router,
      store: loginStore,
    }).$mount('.login-content');
  });
}).catch(() => {
  // Vue error page
  new Vue(LoadErrorComponent).$mount('.login-content');
});
